import { ArrowRight, CalendarCheck, MousePointer2 } from "lucide-react";
import { Link } from "react-router-dom";
import { AppShot } from "./AppShot";

export function HeroSection({ onNavigate }) {
  return (
    <section className="landing-hero is-editorial" data-testid="landing-hero">
      <p className="landing-eyebrow landing-reveal">OFFICINA TOOL CONTROL · PLM PER LA MECCANICA DI PRECISIONE</p>
      <h1 className="landing-reveal" style={{ transitionDelay: "80ms" }}>
        Dall'utensile alla consegna:<br />la tua officina <span className="gold">sotto controllo</span>
      </h1>
      <p className="landing-sub landing-reveal" style={{ transitionDelay: "160ms" }}>
        Utensili, magazzino, acquisti, produzione, qualità e preventivi in un'unica piattaforma per le officine
        di meccanica di precisione. Meno fermi macchina, costo per pezzo reale, margine di commessa che si vede.
      </p>
      <div className="landing-hero-actions landing-reveal" style={{ transitionDelay: "240ms" }}>
        <a className="landing-login-btn is-large" href="#demo" data-testid="hero-cta-demo">
          <CalendarCheck size={17} />Prenota una demo di 20 minuti
        </a>
        <Link
          className="landing-outline-btn"
          to="/registra-azienda"
          onClick={onNavigate("/registra-azienda")}
          data-testid="hero-cta-trial"
        >
          Prova con i tuoi dati <ArrowRight size={15} />
        </Link>
      </div>
      <p className="landing-microcopy landing-reveal" style={{ transitionDelay: "300ms" }} data-testid="hero-microcopy">
        Nessuna carta di credito · Piano Free per sempre · Export Excel e PDF sempre disponibile
      </p>

      <AppShot
        video="planner-demo"
        poster="planner-demo-poster.jpg"
        alt="Registrazione del planner settimanale: carichi macchina, collo di bottiglia e fasi in avanzamento"
        label="PLANNER SETTIMANALE · VIDEO REALE"
        caption="Registrato dentro l'applicazione, senza audio: carichi di reparto, collo di bottiglia, fasi in avanzamento e vista per risorsa."
        testId="hero-app-shot"
        wide
      />

      <p className="landing-hint landing-reveal" data-testid="landing-hint">
        <MousePointer2 size={13} /> Esperienza interattiva — muovi il cursore tra le particelle
      </p>
    </section>
  );
}
